import { render, staticRenderFns } from "./management.vue?vue&type=template&id=3cfc1ad2&scoped=true&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"
import style0 from "./management.vue?vue&type=style&index=0&id=3cfc1ad2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc1ad2",
  null
  
)

component.options.__file = "management.vue"
export default component.exports